module.exports = __webpack_public_path__ + "img/ic_nav_plus.7998b68d.svg";